import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import Select from 'react-select';
import { Badge } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import DataTable from 'react-data-table-component';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { setAlert } from '../../../actions/alert';
import { buscarInventario } from '../../../actions/inventario';
import { buscarProveedores } from '../../../actions/proveedores';
import { filtrarMetodosConfiguracion } from '../../../actions/configuracion';
import { crearOrden, filtarProductos } from '../../../actions/ordenes';

import { formatNumber, roundNumber } from '../../../utils/generalFunctions';

import FiltrosProducto from './FiltrosProducto';

import { CustomValueContainer } from '../../../components/react_select/ReactSelect';

const NuevaOrden = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Ordenes',
            path: '/egresos/ordenes'
        },
        {
            activo: true,
            nombre: 'Nueva orden',
            path: '/egresos/ordenes/nuevo'
        }
    ];

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { listado: listado_proveedores } = useSelector(state => state.proveedores);
    const { listado: listado_metodos } = useSelector(state => state.configuracion.metodos);
    const { listado: listado_productos } = useSelector(state => state.inventario);

    const [ordenData, setOrdenData] = useState({
        id_proveedor: null,
        id_metodo: null,
        numero_documento: '',
        monto_calculado: 0,
        monto_real: 0,
        productos: []
    });

    const [proveedorData, setProveedorData] = useState(null);
    const [proveedoresFilter, setProveedoresFilter] = useState([]);

    const [metodoData, setMetodoData] = useState(null);
    const [metodosFilter, setMetodosFilter] = useState([]);

    const [productosSurtir, setProductosSurtir] = useState([]);
    const [productosTotales, setProductosTotales] = useState([]);

    const [unidadesData, setUnidadesData] = useState([]);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columnsAdd = [
        {
            name: '',
            grow: 0,
            cell: (row, index) => {
                return(
                    <div className="form-check" key={'producto-' + row.id}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={'producto-' + row.id}
                            onChange={e => handleCheckboxRemove(e, index)}
                        />
                    </div>
                )
            }
        }, 
        {
            name: 'Nombre',
            selector: row => row.nombre,
            grow: 2,
            wrap: true
        },
        {
            name: 'Costo',
            cell: (row, index) => formatNumber(row.precio_compra / (unidadesData[index]?.cantidad || 1), 2, '$ ', '')
        }, 
        {
            name: 'Reorden',
            selector: row => formatNumber(row.reorden, 0, '', '')
        },
        {
            name: 'Cantidad actual',
            cell: (row, index) => {
                return(
                    <div className="w-100 text-end">
                        <h5><Badge bg={(row.cantidad * (unidadesData[index]?.cantidad || 1)) > row.reorden ? 'success' : ((row.cantidad * (unidadesData[index]?.cantidad || 1)) < row.reorden ? 'danger' : 'warning')}>{roundNumber(row.cantidad * (unidadesData[index]?.cantidad || 1), 2)}</Badge></h5>
                    </div>
                )
            }
        }, 
        {
            name: 'Cantidad a surtir',
            cell: (row, index) => {
                return(
                    <input type="number" className="form-control" value={ordenData.productos[index]?.cantidad_surtir} onChange={e => handleCantidadChange(e, index)}/>
                )
            }
        }, 
        {
            name: 'Unidad',
            grow: 1.5,
            cell: (row, index) => {
                return(
                    <div className="input-group h-100 py-2">
                        <Select
                            className="select-group"
                            classNamePrefix="react-select"
                            placeholder="Inventario"
                            options={row.unidades}
                            value={unidadesData[index]}
                            isClearable={true}
                            onChange={(value) => handleSelectUnidad(value, index)}
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            components={{
                                ValueContainer: CustomValueContainer
                            }}
                            styles={{ ...styles_select }}
                        />
                    </div>
                )
            }
        }, 
        {
            name: 'Cantidad nueva',
            cell: (row, index) => {
                return(
                    <div className="w-100 text-end">
                        <h5><Badge bg={((row.cantidad * (unidadesData[index]?.cantidad || 1)) + parseFloat(ordenData.productos[index]?.cantidad_surtir)) > row.reorden ? 'success' : (((row.cantidad * (unidadesData[index]?.cantidad || 1)) + parseFloat(ordenData.productos[index]?.cantidad_surtir)) < row.reorden ? 'danger' : 'warning')}>{roundNumber((row.cantidad * (unidadesData[index]?.cantidad || 1)) + parseFloat(ordenData.productos[index]?.cantidad_surtir), 2)}</Badge></h5>
                    </div>
                )
            }
        }
    ];

    const columnsAll = [
        {
            name: '',
            grow: 0,
            cell: row => {
                return(
                    <div className="form-check" key={'producto-' + row.id}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={'producto-' + row.id}
                            onChange={e => handleCheckboxAdd(e)}
                        />
                    </div>
                )
            }
        }, 
        {
            name: 'Nombre',
            selector: row => row.nombre,
            grow: 2,
            wrap: true
        },
        {
            name: 'Categoría',
            selector: row => row.categoria.nombre || 'Sin definir'
        },
        {
            name: 'Subcategoría',
            selector: row => row.subcategoria.nombre || 'Sin definir'
        },
        {
            name: 'Subsubcategoría',
            selector: row => row.subsubcategoria.nombre || 'Sin definir'
        },
        {
            name: 'Código de barras',
            selector: row => row.codigo_barras
        },
        {
            name: 'Reorden',
            selector: row => formatNumber(row.reorden, 0, '', '')
        },
        {
            name: 'Cantidad actual',
            cell: row => {
                return(
                    <div className="w-100 text-end">
                        <h5><Badge bg={row.cantidad > row.reorden ? 'success' : (row.cantidad < row.reorden ? 'danger' : 'warning')}>{roundNumber(row.cantidad, 2)}</Badge></h5>
                    </div>
                )
            }
        }
    ];

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "15px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Nueva orden */
    const handleSelectProveedor = (option) => {
        setOrdenData({
            ...ordenData,
            id_proveedor: option ? option.value : null
        });

        setProveedorData(option);
    }

    const handleSelectMetodo = (option) => {
        setOrdenData({
            ...ordenData,
            id_metodo: option ? option.value : null
        });

        setMetodoData(option);
    }

    const handleNumberChange = (value) => {
        setOrdenData({
            ...ordenData,
            monto_real: value || ''
        });
    }

    const handleNumeroDocumentoChange = ({ target }) => {
        setOrdenData({
            ...ordenData,
            numero_documento: target.value
        });
    }

    /* Filtros de busqueda */
    const handleFiltrosBusqueda = () => {
        dispatch(filtarProductos(true));
    }

    /* Agregar producto */
    const handleCheckboxAdd = ({ target }) => {
        const productoId = target.id.split('-')[1];

        let producto_surtir = productosTotales.find(producto => producto.id == productoId);

        if (producto_surtir) {
            let producto_existente = productosSurtir.find(producto => producto.id == producto_surtir.id);

            setProductosTotales(productosTotales.filter(producto => producto.id != productoId));

            if(!producto_existente){

                setProductosSurtir([
                    ...productosSurtir, 
                    producto_surtir
                ]);

                let productos = ordenData.productos;
                let unidades = unidadesData;

                productos.push({
                    id: productoId, 
                    unidad: null, 
                    conversion: 1, 
                    cantidad_actual: producto_surtir.cantidad,
                    cantidad_surtir: 0
                });

                unidades.push(null);

                setOrdenData({
                    ...ordenData, 
                    productos
                });

                setUnidadesData(unidades);
            }else{
                dispatch(setAlert('Ya tienes este producto en el listado a surtir', 'danger'));
            }
        }
    }

    const handleCantidadChange = ({ target }, posicion) => {        
        let productos = ordenData.productos;
        let monto_calculado = 0;
        
        productos[posicion].cantidad_surtir = target.value || '';

        for (var i = 0; i < productosSurtir.length; i++) {
            monto_calculado += parseFloat(productos[i].cantidad_surtir) * (productosSurtir[i].precio_compra / (unidadesData[i]?.cantidad || 1));
        }

        setOrdenData({
            ...ordenData,
            productos, 
            monto_calculado
        });
    }

    const handleSelectUnidad = (option, posicion) => {
        let productos = ordenData.productos;
        let unidades = unidadesData;
        let monto_calculado = 0;

        unidades[posicion] = option;

        productos[posicion].unidad = option ? option.value : null;
        productos[posicion].conversion = option ? option.cantidad : 1;

        for (var i = 0; i < productosSurtir.length; i++) {
            monto_calculado += parseFloat(productos[i].cantidad_surtir) * (productosSurtir[i].precio_compra / (productos[i].conversion || 1));
        }

        setUnidadesData(unidades);

        setOrdenData({
            ...ordenData,
            productos, 
            monto_calculado
        });
    }

    /* Remover producto */
    const handleCheckboxRemove = ({ target }, posicion) => {
        const productoId = target.id.split('-')[1];

        let producto_eliminar = productosSurtir.find(producto => producto.id == productoId);

        if (producto_eliminar) {
            let producto_existente = productosTotales.find(producto => producto.id == producto_eliminar.id);
            let productos_surtir = productosSurtir.filter(producto => producto.id != productoId);

            setProductosSurtir(productos_surtir);

            if(!producto_existente){
                let productos_totales = [
                    ...productosTotales, 
                    producto_eliminar
                ];

                productos_totales = productos_totales.sort(function (a, b) {
                    if (a.nombre > b.nombre) {
                        return 1;
                    }
                    if (a.nombre < b.nombre) {
                        return -1;
                    }
                    return 0;
                });

                setProductosTotales(productos_totales);
            }else{
                dispatch(setAlert('Ya tienes este producto en el listado total', 'danger'));
            }

            let productos = ordenData.productos;
            let unidades = unidadesData;
            let monto_calculado = 0;

            productos.splice(posicion, 1);
            unidades.splice(posicion, 1);

            for (var i = 0; i < productos_surtir.length; i++) {
                monto_calculado += parseFloat(productos[i].cantidad_surtir) * (productos_surtir[i].precio_compra / (unidades[i]?.cantidad || 1));
            }

            setOrdenData({
                ...ordenData, 
                productos, 
                monto_calculado
            });

            setUnidadesData(unidades);
        }
    }

    const handleGuardarOrden = async () => {
        if(!ordenData.numero_documento){
            await dispatch(setAlert('El número de documento es requerido', 'danger'));
        }else if(ordenData.productos.length > 0){
            await dispatch(crearOrden(ordenData));

            await navigate("/egresos/ordenes");
        }else{
            await dispatch(setAlert('Debe de haber al menos un producto', 'danger'));
        }
    }

    useEffect(() => {
        dispatch(buscarProveedores());
        dispatch(filtrarMetodosConfiguracion(5));
        dispatch(buscarInventario({
            nombre: null, 
            categoria: null, 
            subcategoria: null, 
            subsubcategoria: null, 
            codigo_barras: null, 
            status: 0, 
            tipo_unidades: 1
        }));
    }, []);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_proveedores.length; i++) {
            options.push({ value: listado_proveedores[i].id, label: listado_proveedores[i].alias ? listado_proveedores[i].alias + ' (' + listado_proveedores[i].razon_social + ')' : listado_proveedores[i].razon_social });
        }

        setProveedoresFilter(options);
    }, [listado_proveedores]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_metodos.length; i++) {
            options.push({ value: listado_metodos[i].id, label: listado_metodos[i].nombre });
        }

        setMetodosFilter(options);
    }, [listado_metodos]);

    useEffect(() => {
        setProductosTotales(listado_productos);
    }, [listado_productos]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);    

    return (
        <Fragment>

            <FiltrosProducto />

            <div className="row">
                <div className="col-md-12 px-4 pb-4">
                    <h3 className="mb-5 mt-5">Nueva orden</h3>

                    <div className="row mb-3">
                        <div className="col-md-5 form-group mb-2">
                            <div className="input-group h-100">
                                <Select
                                    name="id_proveedor"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Proveedor"
                                    options={proveedoresFilter}
                                    value={proveedorData}
                                    isClearable={true}
                                    onChange={(value) => handleSelectProveedor(value)}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{
                                        ValueContainer: CustomValueContainer
                                    }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>

                        <div className="col-md-4 form-group mb-2">
                            <div className="input-group h-100">
                                <Select
                                    name="id_metodo"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Método de pago"
                                    options={metodosFilter}
                                    value={metodoData}
                                    isClearable={true}
                                    onChange={(value) => handleSelectMetodo(value)}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{
                                        ValueContainer: CustomValueContainer
                                    }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input
                                        id="numero_documento"
                                        name="numero_documento"
                                        type="text"
                                        className="form-control"
                                        placeholder="Número de documento"
                                        value={ordenData.numero_documento || ''}
                                        onChange={e => handleNumeroDocumentoChange(e)}
                                    />
                                    <label htmlFor="numero_documento">Número de documento</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-2 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input
                                        id="monto_calculado"
                                        name="monto_calculado"
                                        type="text"
                                        className="form-control text-center"
                                        value={formatNumber(ordenData.monto_calculado, 2, '', '')}
                                        disabled
                                    />
                                    <label htmlFor="monto_calculado">Monto calculado</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-2 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <CurrencyInput
                                        id="monto_real"
                                        name="monto_real"
                                        className="form-control text-center"
                                        value={ordenData.monto_real || ''}
                                        decimalsLimit={2}
                                        groupSeparator=","
                                        decimalSeparator="."
                                        onValueChange={(value) => handleNumberChange(value)}
                                    />
                                    <label htmlFor="monto_real">Monto real</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr className="mt-5" />

                    <div className="row mb-3">
                        <h5>Productos a surtir</h5>

                        <DataTable 
                            columns={columnsAdd}
                            data={productosSurtir}
                            highlightOnHover={true}
                        />

                        <div className="col-md-12 mt-4">
                            <button className="btn btn-success float-end" onClick={handleGuardarOrden}>Guardar</button>
                            <Link to='/egresos/ordenes'><button className="btn btn-danger float-end me-2">Cancelar</button></Link>
                        </div>
                    </div>

                    <hr className="mt-5" />

                    <div className="row mb-3">
                        <h5>Productos totales</h5>

                        <div className="d-flex justify-content-end mb-3">
                            <button type="button" className="btn btn-secondary mx-1" onClick={() => handleFiltrosBusqueda()}>Filtros de búsqueda</button>
                        </div>

                        <DataTable 
                            columns={columnsAll}
                            data={productosTotales}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default NuevaOrden;